import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Threetwoseaterbusrentinpune() {



  const cardData = {
"keyword": "32 Seater Bus Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable 32 Seater Bus Rent in Pune for large group travel including family functions, corporate tours, weddings, school trips, pilgrimage journeys, and outstation travel. Our spacious AC 32 seater buses with pushback seats and experienced drivers ensure safe, comfortable, and budget-friendly group transportation across Pune and Maharashtra.",

"topPlaces": [
{
"title": "Shani Shingnapur",
"description":
"Shani Shingnapur is a famous pilgrimage village known for the Shani Temple where Lord Shani is worshipped. It is a highly visited spiritual destination from Pune, often preferred by group travelers using 32 seater buses for comfortable temple darshan and religious tours."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a beautiful hill station known for Arthur Lake, Randha Falls, and lush green valleys. It is a peaceful weekend getaway from Pune, popular for group tours and nature trips using 32 seater buses."
},
{
"title": "Kaas Plateau",
"description":
"Kaas Plateau, also called the Valley of Flowers of Maharashtra, is a UNESCO World Heritage site famous for seasonal wildflowers and biodiversity. It is a popular monsoon tourism destination for group travel from Pune."
},
{
"title": "Amboli",
"description":
"Amboli is a scenic hill station in the Sahyadri range known for waterfalls, misty valleys, and monsoon beauty. It is widely chosen for long group trips and nature tours from Pune using 32 seater buses."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular stop for long-distance group travel and leisure tours from Pune."
},
{
"title": "Dapoli",
"description":
"Dapoli is a peaceful coastal destination known for clean beaches, dolphin spotting, and calm surroundings. It is ideal for family and group tours from Pune using 32 seater buses."
},
{
"title": "Murud-Janjira",
"description":
"Murud-Janjira is famous for its sea fort located on an island, attracting history lovers and tourists. It is a popular coastal sightseeing destination for group tours from Pune."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic monsoon destination known for waterfalls, foggy mountains, and lush greenery. It is one of the most popular short road trips from Pune for group travel."
},
{
"title": "Pawna Lake",
"description":
"Pawna Lake is a popular camping and weekend getaway spot near Lonavala known for lakeside tents, bonfires, and sunset views. It is widely chosen for group camping trips from Pune."
},
{
"title": "Ratnagiri",
"description":
"Ratnagiri is a coastal Konkan destination known for beaches, forts, Alphonso mangoes, and long scenic road trips. It is a popular long-distance group travel destination from Pune."
}
],



services: [
  {
    name: "32 Seater Bus Rent in Pune",
    description: "32 seater bus rent in Pune service provides spacious and comfortable transportation for family tours, corporate outings, educational trips, airport transfers, wedding functions, and outstation journeys. Well-maintained buses ensure smooth highway travel suitable for medium and large group transportation requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 32 seater bus reservations."
  },
  {
    name: "32 Seater Bus on Rent in Pune",
    description: "32 seater bus on rent in Pune service offers reliable transportation for sightseeing tours, pilgrimage travel, business trips, school outings, and tourist group journeys. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for long-distance and local travel. Professional drivers ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 32 seater bus bookings."
  },
  {
    name: "32 Seater Bus Price in Pune",
    description: "32 seater bus price in Pune service provides transparent and affordable transportation solutions for weddings, office travel, educational tours, airport transfers, and family vacations. Spacious buses ensure smooth highway travel suitable for all passenger groups and outstation journeys. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 32 seater bus reservations."
  },
  {
    name: "32 Seater Bus On Hire",
    description: "32 seater bus on hire service offers dependable transportation for family functions, corporate travel, school trips, tourist travel, and pilgrimage journeys. Comfortable seating and spacious interiors ensure pleasant travel experiences suitable for local and outstation routes. Professional drivers ensure safe transportation and reliable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient bus hire reservations."
  },
  {
    name: "32 Seater Bus on Hire for Wedding in Pune",
    description: "32 seater bus on hire for wedding in Pune service provides luxurious transportation for wedding guests, family members, bridal parties, and event travel requirements. Spacious seating and elegant interiors ensure smooth travel suitable for marriage ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, hotels, banquet halls, railway stations, and airport terminals across Pune. Flexible booking options allow convenient wedding bus reservations."
  },
  {
    name: "32 Seater Bus on Rent for Marriage",
    description: "32 seater bus on rent for marriage service offers comfortable transportation for wedding events, reception travel, family gatherings, and guest transportation requirements. Spacious buses ensure smooth travel experiences suitable for large family groups and wedding functions. Professional chauffeurs ensure safe driving and reliable transportation services throughout the event schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient marriage bus reservations."
  },
  {
    name: "32 Seater Bus on Rent Corporate Events",
    description: "32 seater bus on rent corporate events service provides professional transportation for office meetings, conferences, employee travel, industrial visits, team outings, and business functions. Spacious buses ensure comfortable travel experiences suitable for executive teams and corporate passengers. Professional drivers ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "32 Seater Bus on Rent for Mahabaleshwar",
    description: "32 seater bus on rent for Mahabaleshwar service provides comfortable hill station transportation for sightseeing tours, family vacations, school trips, and corporate outings from Pune. Spacious seating and smooth suspension ensure pleasant ghat road travel experiences suitable for large groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Mahabaleshwar route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar bus reservations."
  },
  {
    name: "32 Seater AC Bus on Hire",
    description: "32 seater AC bus on hire service offers premium air-conditioned transportation for weddings, business travel, family vacations, airport transfers, and outstation journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC bus reservations."
  },
  {
    name: "32 Seater Non AC Bus on Hire",
    description: "32 seater non AC bus on hire service provides economical transportation for educational tours, local sightseeing, office outings, family gatherings, and budget-friendly group travel requirements. Spacious interiors ensure comfortable seating suitable for all passenger groups. Professional drivers ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC bus reservations."
  },
  {
    name: "32 Seater Bus Hire for Ashtavinayak Darshan",
    description: "32 seater bus hire for Ashtavinayak darshan service offers reliable transportation for Ganpati temple tours, spiritual journeys, family pilgrimages, and group darshan trips from Pune. Spacious buses ensure smooth highway travel suitable for devotees, tourist groups, and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the temple circuit route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ashtavinayak bus reservations."
  },
  {
    name: "32 Seater Bus Hire for 5 Jyotirlinga Darshan",
    description: "32 seater bus hire for 5 Jyotirlinga darshan service provides comfortable transportation for devotees visiting sacred Jyotirlinga temples across Maharashtra and nearby regions. Spacious seating and smooth highway travel ensure pleasant pilgrimage journeys suitable for large spiritual groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Jyotirlinga bus reservations."
  },
  {
    name: "Pune to Konkan Darshan 32 Seater Bus on Rent",
    description: "Pune to Konkan Darshan 32 seater bus on rent service offers premium transportation for beach tourism, temple visits, family vacations, sightseeing tours, and group travel across Konkan destinations. Spacious buses ensure comfortable highway journeys suitable for tourist and pilgrimage groups. Professional drivers ensure safe driving and dependable transportation services throughout the Konkan route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Konkan bus reservations."
  },
  {
    name: "32 Seater Bus on Rent in Hadapsar",
    description: "32 seater bus on rent in Hadapsar service provides dependable transportation for airport transfers, corporate travel, educational tours, family functions, and outstation journeys from Hadapsar Pune. Spacious seating and luggage capacity ensure smooth travel experiences suitable for group passengers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Hadapsar Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "32 Seater Bus on Rent in Pimpri Chinchwad",
    description: "32 seater bus on rent in Pimpri Chinchwad service offers spacious transportation for family tours, business travel, wedding events, educational trips, and tourist journeys from Pimpri Chinchwad Pune. Comfortable interiors ensure pleasant travel experiences suitable for local and outstation group travel. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "Pune to Bhimashankar 32 Seater Bus Hire",
    description: "Pune to Bhimashankar 32 seater bus hire service provides reliable transportation for Jyotirlinga darshan tours, spiritual journeys, sightseeing trips, and pilgrimage travel from Pune. Spacious buses ensure smooth ghat road journeys suitable for devotees and tourist groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Bhimashankar route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Bhimashankar bus reservations."
  },
  {
    name: "Pune to Ashtavinayak 32 Seater Bus on Rent",
    description: "Pune to Ashtavinayak 32 seater bus on rent service offers dependable transportation for Ganpati temple tours, pilgrimage journeys, family travel, and spiritual group tours from Pune. Spacious seating and comfortable interiors ensure smooth highway travel suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and reliable transportation services throughout the temple circuit route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Ashtavinayak bus reservations."
  },
  {
    name: "32 Seater Bus on Rent in Kothrud",
    description: "32 seater bus on rent in Kothrud service provides comfortable transportation for airport transfers, educational tours, office outings, wedding travel, and outstation journeys from Kothrud Pune. Spacious buses ensure smooth travel experiences suitable for family and corporate groups. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Kothrud Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "32 Seater Bus for Corporate Office",
    description: "32 seater bus for corporate office service offers professional transportation for employee movement, industrial visits, conferences, team outings, and business travel requirements. Spacious buses ensure comfortable travel experiences suitable for office staff and executive teams. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from offices, IT parks, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate office bus reservations."
  },
  {
    name: "32 Seater Bus for Outstation from Pune",
    description: "32 seater bus for outstation from Pune service provides dependable long-distance transportation for family vacations, tourist travel, pilgrimage journeys, business trips, and sightseeing tours. Spacious seating and luggage space ensure smooth highway travel suitable for large passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "32 Seater Bus Rental Services in Pune",
    description: "32 seater bus rental services in Pune provide reliable and comfortable transportation for weddings, educational tours, airport transfers, office outings, family functions, and tourist journeys. Spacious interiors and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient bus rental reservations."
  }
],

tableData: [
  ["32 Seater Bus Rent in Pune", "32 Seater Bus on Rent in Pune"],
  ["32 Seater Bus Price in Pune", "32 Seater Bus On Hire"],
  ["32 Seater Bus on Hire for Wedding in Pune", "32 Seater Bus on Rent for Marriage"],
  ["32 Seater Bus on Rent Corporate Events", "32 Seater Bus on Rent for Mahabaleshwar"],
  ["32 Seater AC Bus on Hire", "32 Seater Non AC Bus on Hire"],
  ["32 Seater Bus Hire for Ashtavinayak Darshan", "32 Seater Bus Hire for 5 Jyotirlinga Darshan"],
  ["Pune to Konkan Darshan 32 Seater Bus on Rent", "32 Seater Bus on Rent in Hadapsar"],
  ["32 Seater Bus on Rent in Pimpri Chinchwad", "Pune to Bhimashankar 32 Seater Bus Hire"],
  ["Pune to Ashtavinayak 32 Seater Bus on Rent", "32 Seater Bus on Rent in Kothrud"],
  ["32 Seater Bus for Corporate Office", "32 Seater Bus for Outstation from Pune"],
  ["32 Seater Bus Rental Services in Pune", "32 Seater Bus Rent in Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 32 Seater Bus Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 32 seater bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate events, family tours, and large group travel."
      },
      {
        WhyChooseheading: "Affordable 32 Seater Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 32 seater bus rent in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service in Pune",
        WhyChoosedescription: "Our 32 seater bus rental service in Pune operates 24 hours for airport transfers, wedding transportation, school trips, office outings, pilgrimage journeys, and outstation tours."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC 32 Seater Buses",
        WhyChoosedescription: "All 32 seater buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained to provide safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Travel Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day tours, weekend trips, multi-day outstation journeys, and flexible travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "Perfect for Large Group & Corporate Travel",
        WhyChoosedescription: "The 32 seater bus is ideal for corporate teams, wedding guest transportation, educational tours, picnic groups, tourist travel, and family functions from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune Locations",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 32 seater bus rent in Pune?", answer: "32 seater bus rental service in Pune provides comfortable group transportation for corporate travel, weddings, family tours, school trips, and outstation journeys." },
    { question: "Is 32 seater bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 32 seater bus rental service in Pune." },
    { question: "Can I book 32 seater bus for outstation travel?", answer: "Yes, customers can book 32 seater buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide 32 seater buses for corporate events?", answer: "Yes, Aaradhya Travels provides 32 seater bus rental service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all 32 seater buses air-conditioned?", answer: "Yes, all 32 seater buses are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 32 seater bus online in Pune?", answer: "Yes, customers can easily book 32 seater bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious 32 seater buses suitable for weddings, family vacations, and group tours." },
    { question: "Are 32 seater bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 32 seater bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Gaikwad",
    feedback:
      "We arranged a 32 Seater bus rent in Pune for our office trip and the experience was very well organized. The bus was spacious, clean, and made group travel extremely comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Kulkarni",
    feedback:
      "A 32 Seater bus rental in Pune helped us manage transportation for a family event smoothly. The journey was comfortable, and the vehicle was in excellent condition throughout the trip.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32 Seater Bus Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/32-seater-bus-rent-pune.jpg",
  "description": "Book 32 Seater Bus on rent in Pune with Aaradhya Travels for weddings, corporate events, family trips, airport transfers, and outstation travel. Affordable AC 32 seater bus available for Mahabaleshwar, Goa, Mumbai, Shirdi, and Maharashtra tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2841"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/32-seater-bus-rent-in-pune"
  }
};










  return (
    <div>
<Helmet>
  <title>
    32 Seater Bus Rent in Pune | AC Luxury Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 32 Seater Bus on rent in Pune with Aaradhya Travels. Affordable AC luxury bus available for weddings, corporate events, airport transfers, Mahabaleshwar trips, Goa tours, Mumbai travel, Shirdi pilgrimage, and group outstation travel."
  />

  <meta
    name="keywords"
    content="32 seater bus rent in pune, 32 seater bus on rent in pune, 32 seater bus price in pune, 32 Seater Bus On Hire, 32 seater bus on hire for wedding in pune, 32 seater bus on rent for marriage, 32 Seater Bus on rent Corporate Events, 32 Seater Bus on rent for mahabaleshwar, 32 Seater ac bus on hire"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Threetwoseaterbusrentinpune;